import {
  Component,
  Input,
  OnInit,
  Output,
  ViewChild,
  EventEmitter,
  inject,
  OnDestroy,
  SimpleChanges,
} from '@angular/core';
import { Match, ScheduledItem } from '../../_shared/models/match.model';
import { finalize, Subject, takeUntil } from 'rxjs';
import { StartMatchService } from '../../match-tracker/start-match/start-match.service';
import { BoardHelpService } from '../../match-tracker/tracker-board/board-help.service';
import { LoaderService } from '../../_core/services/loader.service';
import { MatchService } from '../../_core/services/match.service';
import { ServerPickleballOrder } from '../../_shared/models/serverPicklballOrder.model';
import { SetType } from '../../_shared/models/score-format.model';
import { PlayerCourtPosition, PlayerInfo, Point, Server } from '../../_shared/models/point.model';
import { Score } from '../../_shared/models/csTypes/score';
import { Game, GameFormat } from '../../_shared/models/game.model';
import { Set } from '../../_shared/models/set.model';
import { ScoreService } from '../../match-tracker/tracker-board/services/score.service';
import { ClocksService } from '../../clocks/clocks.service';
import { User } from '../../_shared/models/user.model';
import { AuthService } from '../../auth/auth.service';
import { IntennseService } from '../intennse.service';
import { MatchUpStatusEnum } from '../../_shared/models/csTypes/enums/matchup_status';

@Component({
  standalone: false,
  selector: 'app-int-select-server',
  templateUrl: './int-select-server.component.html',
  styleUrls: ['./int-select-server.component.scss'],
})
export class IntSelectServerComponent implements OnInit, OnDestroy {
  intennseService = inject(IntennseService);
  @Input({ required: true }) teamName: string;
  @Input({ required: true }) player: any;
  @Input({ required: true }) color: string;
  @Input({ required: true }) rowHeight: any;
  @Input({ required: true }) match: Match;
  @Input({ required: true }) itemStyle = 'item';
  @Input() serverWinningSide: number;
  @Output() resetServerWinningSide = new EventEmitter();
  @Output() serverSelected = new EventEmitter();
  @Input({ required: true }) isReverse: boolean;
  @Input({ required: false }) sideNumber: number;  
  @Input({ required: false }) selectedTeam: number | null;
  @Output() teamSelected = new EventEmitter<number>(); 
  @Input({ required: true }) hideSelectServingAndServer: boolean;
  @Input({ required: false }) htmlView: boolean;

  private readonly destroy$: Subject<void> = new Subject(); 
  private side1PlayerPosition: PlayerCourtPosition = {};
  private side2PlayerPosition: PlayerCourtPosition = {};
  public selectedPlayerId: string | null = null;
  public selectedPlayerInfo: any;

  constructor(
    private startMatchService: StartMatchService,
    private bhs: BoardHelpService,
    private loader: LoaderService,
    private matchService: MatchService, 
    private scoreService: ScoreService,
    private clocksService: ClocksService,
    private authService: AuthService,
  ) {}
  ngOnInit() {
    if(this.htmlView){
      return
    }
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes?.selectedTeam?.currentValue == null && this.match.matchStatus === MatchUpStatusEnum.TBP){
        this.selectedTeam =  null;
        this.selectedPlayerId = null;
        this.scoreService.resetPlayerPositions();
        this.intennseService.setFirstTimeServer(null);
        this.selectedPlayerInfo = null;
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

    async startMatchIntennse() {
        let selectedServer: Server | null = this.intennseService.getFirstTimeServer();
        let serverPickleballOrders: ServerPickleballOrder[] = [];
        const scoreFormat = this.bhs.getScoreFormat(
            this.match.matchFormat,
            this.match?.discipline
        );
        await this.loader.present();
        const authUser: User = await this.authService.getAuthUser();
        const playerCourtTimeLog = this.startMatchService.convertToPlayerCourtTimeLogFormat(this.match.sides, authUser?._id);
        const scheduledItemObj: ScheduledItem = {
            itemType: 'startTime',
            itemSubject: 'MATCHUP',
        };

        const point = new Point();
        point.side1Score = 0;
        point.side2Score = 0;

        point.shots = [];
        point.pointNumber = 1;
        point.timeout = []
        point.extensions.push({
            name: 'areSidesReversed',
            value: this.isReverse ? true : false,
        });
        point.playerPositions = {
            side1: this.scoreService.getPlayerPosition(1),
            side2: this.scoreService.getPlayerPosition(2),
        }
        point.startPointTimeStamp = new Date();
        point.onCourtPlayers = this.bhs.getOnCourtPlayersFromSides(this.match);

        point.startPointTimeStamp = new Date();
        const onCourtPlayers = this.bhs.getOnCourtPlayersFromSides(this.match);
        if(onCourtPlayers){
          point.onCourtPlayers = onCourtPlayers;
        }
        if (selectedServer) {
            const  scoreFormat = this.bhs.getScoreFormat(
              this.match.matchFormat,
              this.match.discipline
            );
            selectedServer.returningSide = this.bhs.getReturningSide(point.pointNumber, this.match, scoreFormat); 
            point.server = selectedServer;
        }
        const {timeoutPerSet,remainingTimeoutsPerSet, timeoutPerMatch, remainingTimeoutsPerMatch} = this.clocksService.getTimeoutClockDetails(this.match)
        const game = new Game();
        game.gameFormat =
            scoreFormat.setType === SetType.TIEBREAK
              ? GameFormat.TIEBREAK
              : GameFormat.STANDARD;
        game.points.push(point);
        game.gameNumber = 1;
        const set = new Set();
        set.serverPickleballOrders = serverPickleballOrders;
        set.games?.push(game);
        set.setNumber = 1;

        const score: Score = {
            scoreStringSide1: '0',
            scoreStringSide2: '0',
            side1PointScore: '0',
            side2PointScore: '0',
            server: selectedServer,
            sets: [
              {
                setNumber: 1,
                side1Score: 0,
                side2Score: 0,
                side1TiebreakScore: null,
                side2TiebreakScore: null,
                games: [],
                serverPickleballOrders,
                timeout: timeoutPerSet > 0  ? {
                  side1: {
                    timeoutPerSet: timeoutPerSet, 
                    remainingTimeoutsPerSet: remainingTimeoutsPerSet,
                    timeoutPerMatch: timeoutPerMatch,
                    remainingTimeoutsPerMatch: remainingTimeoutsPerMatch,
                  }, side2: {
                    timeoutPerSet: timeoutPerSet, 
                    remainingTimeoutsPerSet: remainingTimeoutsPerSet,
                    timeoutPerMatch: timeoutPerMatch,
                    remainingTimeoutsPerMatch: remainingTimeoutsPerMatch,
                  }
                } : {}
              },
            ],
        };

        const notification = {
            title: 'Match has started',
            body: `${this.bhs.getPlayersNames(
              this.match,
              1
            )} - ${this.bhs.getPlayersNames(this.match, 2)}`,
        };

        this.startMatchService
            .startMatch(
              this.match._id,
              scheduledItemObj,
              [set],
              notification,
              score,
              playerCourtTimeLog
            )
            .pipe(
              takeUntil(this.destroy$),
              finalize(() => this.loader.dismiss())
            )
            .subscribe({
              next: (res) => {
                this.match.scheduledItems = res.data;
                this.match.sets = [set];
                this.match.score = score;
                this.match.matchStatus = 'IN_PROGRESS';
                this.match.startDate = new Date();
                this.match.playerCourtTimeLog = playerCourtTimeLog;
                this.startMatchService.publishStartMatch(this.match._id, true);
                this.matchService.publishScoreUpdated(this.match);
              },
            });
    }

    private getPlayers(
        match: Match,
      ): PlayerInfo {
        const players: any = {};
    
        match.sides.forEach((side, i) => {
          players[i + 1] = side.players.map((player, j) => ({
            playerName: this.bhs.getPlayersNames(
              match,
              side.sideNumber,
              'full',
              j + 1
            ),
            sideNumber: i + 1,
            playerNumber: j + 1,
            player: player.participant?._id || null,
          }));
        });
        return players;
    }

    async selectServer(palyerId: any, playerNumber: number) {
        const players = this.getPlayers(this.match);
        this.selectedPlayerId = palyerId;

        if (this.serverWinningSide && this.serverWinningSide !== 0) {
          const selectedServer = {
            sideNumber:this.serverWinningSide,
            playerNumber: playerNumber,
            returnerPlayerNumber: playerNumber ? 1 : 2,
            palyerId: palyerId 
          }
          await this.scoreService.assignPlayerPositions(players, selectedServer);
          /**
           * This will notify to update score with player positions
           */
          this.scoreService.updateScoreForServingPlayer(selectedServer, {
            side1: this.scoreService.getPlayerPosition(1),
            side2: this.scoreService.getPlayerPosition(2)
          });

          this.resetServerWinningSide.emit(true);
        } else {
            let selectedServer: Server | null;
            selectedServer = await this.bhs.selectServerPlayer(
              this.match,
              palyerId
            );            
            if (!selectedServer) return;
            await this.scoreService.assignPlayerPositions(players, selectedServer);
            await this.intennseService.setFirstTimeServer(selectedServer);
            this.serverSelected.emit(true);
            this.selectedPlayerInfo = this.intennseService.getFirstTimeServer();
        }
    }

    async selectTeam(sideNumber: number){
      this.selectedTeam = sideNumber;
      await this.intennseService.setTeamSelection(sideNumber);
      this.teamSelected.emit(sideNumber);
    }
}
